<div style="display:flex; justify-content:space-between">
  <div mat-dialog-title>Report Viewer</div>
  @if (reportData.options && reportData.options.length > 0) {
    <div style="display:flex; flex-direction:column;margin-bottom: 1em;">
      <div><b>Options:</b></div>
      @if (reportData.options.length == 1) {
        <div>
          <mat-checkbox [(ngModel)]="reportData.options[0].isChecked" (change)="refreshReport()" name="repOption" ngDefaultControl>{{reportData.options[0].label}}</mat-checkbox>
        </div>
      }
      @if (reportData.options.length > 1) {
        <div>
          <mat-radio-group [(value)]="reportOption" name="repOptions" (change)="reportOptionChange($event)">
            @for (opt of reportData.options; track opt) {
              <div>
                <mat-radio-button [value]="opt.reportname"></mat-radio-button>
                <span>{{ opt.label }}</span>
              </div>
            }
          </mat-radio-group>
        </div>
      }
    </div>
  }
  <!--If more than one option then make a radio button-->
  @if (reportData.hasExcel) {
    <div>
      <button mat-button (click)="downloadExcel()">EXCEL DOWNLOAD</button>
    </div>
  }
</div>
<mat-dialog-content>
  @if (isReady) {
    <ngx-extended-pdf-viewer [src]="report"
      useBrowserLocale="true"
      [showBookmarkButton]="false"
      [showOpenFileButton]="false"
    ></ngx-extended-pdf-viewer>
  } @else {
    <div style="width: 40em;">Loading...</div>
  }
</mat-dialog-content>
<mat-dialog-actions style="display: flex; flex-direction: row; justify-content: flex-end;">
  <button mat-button (click)="close()">CLOSE</button>
</mat-dialog-actions>

